import { render } from "./FileBrowser.vue?vue&type=template&id=2c320f0d"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__